import React from 'react';

import './checkbox.scss';

const Checkbox = ({ value, checked, title, onChange }) => {
  return (
    <div className="new">
      <div className="form-group">
        <input
          type="checkbox"
          checked={checked}
          onChange={onChange}
          id={value}
        />
        <label htmlFor={value}>{title}</label>
      </div>
    </div>
  );
};

export default Checkbox;
